<template>
  <div :class="classes">
    <div
      v-if="hasTitle"
      class="form-wrapper-header"
    >
      <div
        v-if="hasIcon"
        class="form-wrapper-icon"
      >
        <rt-icon
          :name="icon"
          :size="22"
        />
      </div>
      <span class="form-wrapper-title">{{ title }}</span>
      <div class="form-wrapper-btns">
        <slot name="btn" />
      </div>
    </div>
    <div class="form-wrapper-body">
      <slot />
    </div>
  </div>
</template>

<script>
import RtIcon from '../icon/rtIcon.vue';
export default {
  name: 'RtFormWrapper',
  components: { RtIcon },
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  computed: {
    hasIcon () {
      return !!this.icon;
    },
    hasTitle () {
      return !!this.title;
    },
    classes () {
      return [
        'rt-form-wrapper',
        {
          'has-title': this.hasTitle
        }
      ];
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtFormWrapper.vue?713ab6a9